import { appHttpClient } from "../../installations/http/axiosInterfaces";

export const addOrUpdateConfiguration = (data) => {
  return appHttpClient.post(`/WebsiteConfiguration/AddOrUpdate`, data);
};

export const deleteConfiguration = (key) => {
  return appHttpClient.post(`/WebsiteConfiguration/Delete`, {
    params: { key },
  });
};

export const getConfigurationByKey = (key) => {
  return appHttpClient.get(`/WebsiteConfiguration/GetByKey`, {
    params: { key },
  });
};

export const getAllConfigurations = () => {
  return appHttpClient.get(`/WebsiteConfiguration/List`);
};

export const uploadImage = (type, formData) => {
  return appHttpClient.post(`/WebsiteConfiguration/Upload/${type}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const deleteHomeBanner = (bannerId) => {
  return appHttpClient.post(`/WebsiteConfiguration/Delete/HomeBanner/${bannerId}`);
};

const websiteConfigurationService = {
  addOrUpdateConfiguration,
  deleteConfiguration,
  getConfigurationByKey,
  getAllConfigurations,
  uploadImage,
  deleteHomeBanner,
};

export default websiteConfigurationService;
